import theme from '../../themes/theme';

const { appColors } = theme;
const flexDefaultProps = () => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignSelf: 'stretch',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
});

const infoTextStyles = () => ({
  height: '3em',
  color: appColors.regularText,
  fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
  fontSize: '1.25em',
  fontWeight: 600,
});

export default {
  container: {
    ...flexDefaultProps(),
    flex: 1,
    width: '100%',
    paddingTop: '2.5em',
    paddingLeft: '2.125em',
    color: appColors.regularText,
  },
  leftPanel: {
    ...flexDefaultProps(),
    flex: 3,
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  centerPanel: {
    ...flexDefaultProps(),
    flex: 3,
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  rightPanel: {
    ...flexDefaultProps(),
    flex: 6,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingLeft: '2.25em',
  },
  panelTitleText: {
    color: appColors.titleText,
    height: '1.625em',
    fontSize: '1.125em',
    fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
    fontWeight: 'normal',
    letterSpacing: '-0.03125em',
  },
  panelSection: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignSelf: 'flex-start',
  },
  weatherIcon: {
    marginTop: '0.75em',
    height: '3em',
    alignItems: 'flex-start',
  },
  weatherText: {
    ...infoTextStyles(),
    marginTop: '0.625em',
  },
  additionalInfo: {
    ...infoTextStyles(),
    height: '1.625em',
  },
  temperature: {
    color: appColors.regularText,
    fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
    fontSize: '3em',
    fontWeight: 'normal',
    height: '1.25em',
    letterSpacing: '-0.03125em',
    width: '2.9375em',
  },
  diagonal: {
    width: '6.25em',
  },
  highLowTempSection: {
    display: 'flex',
    flexBasis: '75%',
    alignSelf: 'flex-start',
    flexDirection: 'row',
    width: '12.5em',
  },
  highTemp: {
    ...flexDefaultProps(),
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  tempDivider: {
    ...flexDefaultProps(),
    flex: 1,
    marginLeft: '-2.5em',
    marginTop: '1.5em',
  },
  dividerBox: {
    ...flexDefaultProps(),
    alignSelf: 'center',
    height: '3.75em',
    width: '3.75em',
    padding: 0,
    margin: 0,
  },
  dividerLine: {
    width: '4.25em',
    height: '4.25em',
    borderBottom: `0.05em solid ${appColors.titleText}`,
    position: 'absolute',
    transform: 'translateY(1em) translateX(1em) rotate(-45deg)',
    marginTop: '-2.5em',
    marginLeft: '-2.5em',
  },
  lowTempWrapper: {
    ...flexDefaultProps(),
    flexDirection: 'column',
    flex: 1,
  },
  lowTempTitle: {
    ...flexDefaultProps(),
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  lowTemp: {
    ...flexDefaultProps(),
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
  },
};
